import { render, staticRenderFns } from "./CardsMatrix.vue?vue&type=template&id=3e6e6abd&scoped=true&"
import script from "./CardsMatrix.vue?vue&type=script&lang=js&"
export * from "./CardsMatrix.vue?vue&type=script&lang=js&"
import style0 from "./CardsMatrix.vue?vue&type=style&index=0&id=3e6e6abd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6e6abd",
  null
  
)

export default component.exports